/* eslint-disable eqeqeq */
import { dispatch, app } from "hf-rt";
import { ROOT } from "../constants";
import getCookie from "../function/getCookie";
import deleteCookie from "../function/deleteCookie";
import { setGAEvent } from "../function/setGAEvent";

let gaTimer;

const initialState = {
  cbu: "",
  cci: "",
  isPdtFetchComplete: false,
  loading: true,
  productBookingUnit: {
    media: {}
  },
  product: {
    code: "",
    productTag: ""
  },
  ui: {
    options: [
      {
        optionId: "",
        option: {
          display: {
            lv2: {
              sizeGuideAnchor: ""
            }
          }
        }
      }
    ],
    display: {
      prevCode: "",
      nextCode: "",
      sizeComment: null
    }
  },
  lv1Default: "",
  lv2Default: "",
  lv3Default: "",
  isLv1Click: false,
  isLv2Click: false,
  isLv3Click: false,
  subOptionLv1DisplayList: {
    subitems: []
  },
  subOptionLv1SelectIndex: 0,
  subOptionLv2SelectIndex: 0,
  subOptionLv3SelectIndex: 0,

  //以下fake data
  data: {
    cbu: "",
    details: {
      collection: "",
      name: "",
      originalPrice: "",
      discountPrice: "",
      sellingPrice: "",
      priceInEur: "",
      quantity: 1,
      ringMeasure: []
    },
    info: {
      img: "",
      style: "",
      des: ""
    },
    collections: [],
    recommendation: [],
    recentlyViewed: [],
    gallery: [],
    shopTheLook: {
      bg: "",
      numberLabel: [],
      products: [],
      text: ""
    },
    matchingPdt: []
  },
  activeOptionId: "",
  activeOptionIndex: 0
};
const findCbuCci = (state, lv1Index, lv2Index, lv3Index) => {
  const { activeOptionIndex } = state;
  if (
    state.ui.options[activeOptionIndex].option.relations[
      lv1Index
    ].hasOwnProperty("subitems")
  ) {
    if (
      state.ui.options[activeOptionIndex].option.relations[lv1Index].subitems[
        lv2Index
      ].hasOwnProperty("subitems")
    ) {
      return (
        //有Lv3, cbu, cci 位在這一層
        state.ui.options[activeOptionIndex].option.relations[lv1Index].subitems[
          lv2Index
        ].subitems[lv3Index]
      );
    } else {
      //沒有Lv3, cbu, cci 位在這Lv2層
      return state.ui.options[activeOptionIndex].option.relations[lv1Index]
        .subitems[lv2Index];
    }
  } else {
    //沒有Lv2, cbu, cci 位在這Lv1層
    return state.ui.options[activeOptionIndex].option.relations[lv1Index];
  }
};
const findChannelIndex = (state, lv1Index, lv2Index, lv3Index, array) => {
  let findChannelBookingUnitsIndex;
  let findChannelCatalogItemsIndex;
  //找出cbu, cci
  const id = findCbuCci(state, lv1Index, lv2Index, lv3Index).id;
  const cbu = id.cbu;
  const cci = id.cci;

  let array1;
  let array2;

  array2 = state.channelCatalogItems;
  findChannelCatalogItemsIndex =
    array2.findIndex(e => e.itemId === cci) !== -1
      ? array2.findIndex(e => e.itemId === cci)
      : 0;

  array1 = array[findChannelCatalogItemsIndex].channelBookingUnits;
  findChannelBookingUnitsIndex =
    array1.findIndex(e => e.cbu === cbu) !== -1
      ? array1.findIndex(e => e.cbu === cbu)
      : 0;

  return {
    findChannelBookingUnitsIndex,
    findChannelCatalogItemsIndex,
    cbu,
    cci
  };
};
const codeToIndex = (array, value) => {
  if (array === undefined) return 0;

  const stockAvailableCodeIndex = array.findIndex(
    item =>
      item.hasOwnProperty("id")
        ? item.code === value && item.id.stockAvailable
        : item.code === value //lv1找lv2時，lv1沒有id。
  );
  if (stockAvailableCodeIndex !== -1) {
    //遍歷陣列，找到第1個stockAvailable為true的選項。
    return stockAvailableCodeIndex;
  }
  //遍歷陣列，找不到stockAvailable為true的選項。
  return array.findIndex(item => item.code === value);
};
const findLv2DefaultValue = function(
  relations,
  lv1DefaultIndex,
  defaultShowLv2Code
) {
  let lv2DefaultIndex = 0;

  if (relations[lv1DefaultIndex].hasOwnProperty("subitems")) {
    lv2DefaultIndex = relations[lv1DefaultIndex].subitems.findIndex(
      e => e.code === defaultShowLv2Code
    );
    if (lv2DefaultIndex === -1) lv2DefaultIndex = 0;
  }
  return lv2DefaultIndex;
};
// const findLv3DefaultValue = function(
//   relations,
//   lv1DefaultIndex,
//   lv2DefaultIndex,
//   defaultShowLv3Code
// ) {
//   let lv3DefaultIndex = 0;

//   if (relations[lv1DefaultIndex].hasOwnProperty("subitems")) {
//     if (
//       relations[lv1DefaultIndex].subitems[lv2DefaultIndex].hasOwnProperty(
//         "subitems"
//       )
//     ) {
//       lv3DefaultIndex = relations[lv1DefaultIndex].subitems[
//         lv2DefaultIndex
//       ].subitems.findIndex(e => e.code === defaultShowLv3Code);
//       if (lv3DefaultIndex === -1) lv3DefaultIndex = 0;
//     }
//   }
//   return lv3DefaultIndex;
// };

export default {
  name: "product",
  actions: {
    updateProductByDefault: () =>
      dispatch({ type: "UPDATE_PRODUCT_BY_DEFAULT" }),

    changeLv1SelectOptionDefault: data =>
      dispatch({ type: "CHANGE_LV1_SELECT_OPTION_DEFAULT", data }),

    changeLv2SelectOptionDefault: data =>
      dispatch({ type: "CHANGE_LV2_SELECT_OPTION_DEFAULT", data }),

    changeLv3SelectOptionDefault: data =>
      dispatch({ type: "CHANGE_LV3_SELECT_OPTION_DEFAULT", data }),

    updateLv2List: code => dispatch({ type: "UPDATE_LV2_LIST", code }),

    updateLv3List: code => dispatch({ type: "UPDATE_LV3_LIST", code }),

    updateProductInfo: code => dispatch({ type: "UPDATE_PRODUCT_INFO", code }),

    selectLv1Option: async function(code) {
      await dispatch({ type: "SELECT_LV1_OPTION" });
      await this.updateLv2List(code);
    },

    selectLv2Option: async function(code) {
      await dispatch({ type: "SELECT_LV2_OPTION" });
      await this.updateLv3List(code);
    },

    selectLv3Option: async function(code) {
      await dispatch({ type: "SELECT_LV3_OPTION" });
      await this.updateProductInfo(code);
    },

    clickLv1OptionToChangeLv2: () =>
      dispatch({ type: "CLICK_LV1_OPTION_TO_CHANGE_LV2" }),

    clickLv2OptionToChangeLv3: () =>
      dispatch({ type: "CLICK_LV2_OPTION_TO_CHANGE_LV3" }),

    updatePdt: payload => dispatch({ type: "UPDATE_PDT", payload }),

    startPdtLoading: () => dispatch({ type: "START_PDT_LOADING" }),

    stopePdtLoading: () => dispatch({ type: "STOPE_PDT_LOADING" }),

    fetchProduct: async function(cbu) {
      await this.startPdtLoading();
      await dispatch({ type: "FETCH_PRODUCT" });
      const res = await fetch(app.getURL({ api: "product", params: cbu }));
      if (res.status == 404) {
        const lang = getCookie("eshop-hk-language") || "en";
        window.location.href = `/${lang}/404?proj=r&func=fetchProduct&msg=FETCH_PRODUCT_404`;
      }
      const data = await res.json();
      await this.updatePdt(data); //先載入產品
      await this.updateProductByDefault(); //再載入產品default show
      await this.stopePdtLoading();
      await this.pushSyteList(data);
    },
    pushSyteList: data => {
      function setCookie(name, value, expire_days) {
        const date = new Date();
        date.setTime(date.getTime() + expire_days * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toGMTString();
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
      }
      if (
        Array.isArray(data.channelCatalogItems) &&
        data.channelCatalogItems.length > 0
      ) {
        const code = data.channelCatalogItems[0].code;
        const sku_list = getCookie("syte_sku_list");
        try {
          if (sku_list) {
            const decodeList = decodeURIComponent(sku_list);
            const list = JSON.parse(decodeList);
            const hasValue = list.includes(code);
            if (!hasValue) {
              const value = [...list];
              value.push(code);
              const stringValue = JSON.stringify(value);
              const encodeValue = encodeURIComponent(stringValue);
              setCookie("syte_sku_list", encodeValue, 360);
            }
          } else {
            const value = JSON.stringify([code]);
            const encodeValue = encodeURIComponent(value);
            setCookie("syte_sku_list", encodeValue, 360);
          }
        } catch (error) {
          deleteCookie("syte_sku_list");
        }
      }
    },
    setActiveOption: (id, index) =>
      dispatch({ type: "SET_ACTIVE_OPTION", id, index })
  },
  reducers: function (state = initialState, action) {
    let findSubOptionLv2Index;
    let findSubOptionLv3Index;
    let findChannelBookingUnitsIndex;
    let findChannelCatalogItemsIndex;

    let cbu;
    let cci;
    let index;

    switch (action.type) {
      case "CLICK_LV1_OPTION_TO_CHANGE_LV2":
        return { ...state, isLv1Click: true };
      case "CLICK_LV2_OPTION_TO_CHANGE_LV3":
        return { ...state, isLv2Click: true };
      case "CHANGE_LV1_SELECT_OPTION_DEFAULT":
        return { ...state, lv1Default: action.data };
      case "CHANGE_LV2_SELECT_OPTION_DEFAULT":
        return { ...state, lv2Default: action.data };
      case "CHANGE_LV3_SELECT_OPTION_DEFAULT":
        return { ...state, lv3Default: action.data };
      case "START_PDT_LOADING":
        return { ...state, loading: true };
      case "STOPE_PDT_LOADING":
        return { ...state, loading: false };
      case "UPDATE_LV2_LIST":
        //code 轉成 relations index
        const { activeOptionIndex } = state;
        const lv1Index = codeToIndex(
          state.ui.options[activeOptionIndex].option.relations,
          action.code
        );
        //找出channel index
        index = findChannelIndex(
          state,
          lv1Index,
          0,
          0,
          state.channelCatalogItems
        );
        return {
          ...state,
          subOptionLv1SelectIndex: lv1Index,
          subOptionLv2List:
            state.ui.options[activeOptionIndex].option.relations[lv1Index],
          subOptionLv3List: state.ui.options[
            activeOptionIndex
          ].option.relations[lv1Index].hasOwnProperty("subitems")
            ? state.ui.options[activeOptionIndex].option.relations[lv1Index]
                .subitems[0]
            : {},
          product:
            state.channelCatalogItems[index.findChannelCatalogItemsIndex],
          productBookingUnit:
            state.channelCatalogItems[index.findChannelCatalogItemsIndex]
              .channelBookingUnits[index.findChannelBookingUnitsIndex]
        };
      case "UPDATE_LV3_LIST":
        //code 轉成 relation index
        findSubOptionLv2Index = codeToIndex(
          state.subOptionLv2List.subitems,
          action.code
        );
        //找出channel index
        index = findChannelIndex(
          state,
          state.subOptionLv1SelectIndex,
          findSubOptionLv2Index,
          0,
          state.channelCatalogItems
        );
        return {
          ...state,
          cbu: state.cbu,
          cci: state.cci,
          subOptionLv3List:
            state.ui.options[state.activeOptionIndex].option.relations[
              state.subOptionLv1SelectIndex
            ].subitems[findSubOptionLv2Index],
          product:
            state.channelCatalogItems[index.findChannelCatalogItemsIndex],
          productBookingUnit:
            state.channelCatalogItems[index.findChannelCatalogItemsIndex]
              .channelBookingUnits[index.findChannelBookingUnitsIndex]
        };
      case "UPDATE_PRODUCT_INFO":
        //code 轉成 relation index
        findSubOptionLv3Index = codeToIndex(
          state.subOptionLv3List.subitems,
          action.code
        );
        cbu = state.subOptionLv3List.subitems[findSubOptionLv3Index].id.cbu;
        cci = state.subOptionLv3List.subitems[findSubOptionLv3Index].id.cci;
        findChannelBookingUnitsIndex =
          state.product.channelBookingUnits.findIndex(e => e.cbu === cbu);
        findChannelCatalogItemsIndex = state.channelCatalogItems.findIndex(
          e => e.itemId === cci
        );

        return {
          ...state,
          product: state.channelCatalogItems[findChannelCatalogItemsIndex],
          productBookingUnit:
            state.channelCatalogItems[findChannelCatalogItemsIndex]
              .channelBookingUnits[findChannelBookingUnitsIndex]
        };
      case "UPDATE_PRODUCT_BY_DEFAULT":
        cbu = state.ui.options[state.activeOptionIndex].option.defaultShow.cbu;
        cci = state.ui.options[state.activeOptionIndex].option.defaultShow.cci;
        let lv1DefaultIndex;
        let lv2DefaultIndex;
        //let lv3DefaultIndex;

        const { relations, defaultShow } =
          state.ui.options[state.activeOptionIndex].option;

        /* 找出Lv1 的default 值 */
        lv1DefaultIndex = relations.findIndex(
          e => e.code === defaultShow.lv1Code
        );

        /* 找出Lv2 的default 值 */
        lv2DefaultIndex = findLv2DefaultValue(
          relations,
          lv1DefaultIndex,
          defaultShow.lv2Code
        );

        /* 找出Lv3 的default 值 */
        // lv3DefaultIndex = findLv3DefaultValue(
        //   relations,
        //   lv1DefaultIndex,
        //   lv2DefaultIndex,
        //   defaultShow.lv3Code
        // );

        /* 步驟1: 先找出ChannelCatalogItems 的default 值 */

        findChannelCatalogItemsIndex = state.channelCatalogItems.findIndex(
          e => e.itemId === cci
        );

        /* 步驟2: 再找出這個Catalog下的BookingUnits 的default 值 */
        findChannelBookingUnitsIndex = state.payload.channelCatalogItems[
          findChannelCatalogItemsIndex
        ].channelBookingUnits.findIndex(e => e.cbu === cbu);

        const _activeChannelItem =
          state.channelCatalogItems[findChannelCatalogItemsIndex];
        const _activeBookingUnit =
          state.channelCatalogItems[findChannelCatalogItemsIndex]
            .channelBookingUnits[findChannelBookingUnitsIndex];
        gaTimer = setInterval(() => {
          if (window.dataLayer) {
            setGAEvent("view_item", _activeChannelItem, _activeBookingUnit);
            clearInterval(gaTimer);
          }
        }, 1500);

        return {
          ...state,
          subOptionLv2List: relations[lv1DefaultIndex],
          subOptionLv3List: relations[lv1DefaultIndex].hasOwnProperty(
            "subitems"
          )
            ? relations[lv1DefaultIndex].subitems[lv2DefaultIndex]
            : [],
          product: state.channelCatalogItems[findChannelCatalogItemsIndex],
          productBookingUnit:
            state.channelCatalogItems[findChannelCatalogItemsIndex]
              .channelBookingUnits[findChannelBookingUnitsIndex]
        };
      case "UPDATE_PDT":
        if (action.payload.ui) {
          const { defaultOptionId, options } = action.payload.ui;
          const activeIndex = options.findIndex(
            item => item.optionId === defaultOptionId
          );
          return {
            ...state,
            product: action.payload.channelCatalogItems[0],
            payload: action.payload,
            ui: action.payload.ui,
            channelCatalogItems: action.payload.channelCatalogItems,
            //產品的子選項, 例如: 材質, 圈數, 重量, 長度...等等
            subOptionLv1DisplayList:
              action.payload.ui.options[activeIndex].option.display.lv1,
            subOptionLv2DisplayList:
              action.payload.ui.options[activeIndex].option.display.lv2 || null,
            subOptionLv3DisplayList:
              action.payload.ui.options[activeIndex].option.display.lv3 || null,
            subOptionLv1List:
              action.payload.ui.options[activeIndex].option.display.lv1,
            subOptionLv2List:
              action.payload.ui.options[activeIndex].option.relations[0],
            subOptionLv3List: action.payload.ui.options[
              activeIndex
            ].option.relations[0].hasOwnProperty("subitems")
              ? action.payload.ui.options[activeIndex].option.relations[0]
                  .subitems[0]
              : {},
            productBookingUnit:
              action.payload.channelCatalogItems[0].channelBookingUnits[0],
            activeOptionIndex: activeIndex,
            activeOptionId: defaultOptionId,
            lv1Default:
              action.payload.ui.options[activeIndex].option.defaultShow
                .lv1Code || ""
          };
        } else if (action.payload.channelCatalogItems) {
          return {
            ...state,
            product: action.payload.channelCatalogItems[0],
            payload: action.payload,
            productBookingUnit:
              action.payload.channelCatalogItems[0].channelBookingUnits[0]
          };
        } else {
          return state;
        }
      case "SET_ACTIVE_OPTION":
        const _active = state.ui.options[action.index].option;
        const _product = state.channelCatalogItems.find(
          data => data.itemId === _active.defaultShow.cci
        );
        const _bookingUnit = _product.channelBookingUnits.find(
          data => data.cbu === _active.defaultShow.cbu
        );
        const _hasLv1 = _active.defaultShow.lv1Code;
        let _lv1Index = state.subOptionLv1SelectIndex;
        if (_hasLv1) {
          _lv1Index = _active.display.lv1.subitems.findIndex(
            data => data.code === _hasLv1
          );
        }

        return {
          ...state,
          activeOptionId: action.id,
          activeOptionIndex: action.index,
          subOptionLv1DisplayList:
            state.ui.options[action.index].option.display.lv1,
          subOptionLv2DisplayList:
            state.ui.options[action.index].option.display.lv2 || null,
          subOptionLv3DisplayList:
            state.ui.options[action.index].option.display.lv3 || null,
          subOptionLv1List: state.ui.options[action.index].option.display.lv1,
          subOptionLv2List: state.ui.options[action.index].option.relations[0],
          subOptionLv3List: state.ui.options[
            action.index
          ].option.relations[0].hasOwnProperty("subitems")
            ? state.ui.options[action.index].option.relations[0].subitems[0]
            : {},
          product: _product,
          productBookingUnit: _bookingUnit,
          lv1Default: _active.defaultShow.lv1Code || "",
          lv2Default: _active.defaultShow.lv2Code || "",
          lv3Default: _active.defaultShow.lv3Code || "",
          subOptionLv1SelectIndex: _lv1Index
        };

      default:
        return state;
    }
  }
};
